import React from 'react';
import UserAvatar from '../../Avatar';

/**
 * Comments
 *
 * @param {Object} props
 *
 */
const Comments = props => {
    const comments = props.comments.map((comment, index) => {
        let className = 'hk-userreview hk-userhike';
        if (props.comments.length === 1) {
            className = 'hk-userreview hk-onlycomment';
        } else if (index === 0) {
            className = 'hk-userreview hk-firstcomment';
        } else if (index === props.comments.length - 1) {
            className = 'hk-userreview hk-lastcomment';
        }
        return <Comment key={index} comment={comment} className={className} />;
    });
    return (
        <div className='comments-container'>
            <div className='comments-list'>
                {comments}
            </div>
        </div>
    );
};


/**
 * Comment
 *
 * @param {Object} props
 *
 */
const Comment = props => {
    const usernameStyle = {
        marginLeft: '10px',
        marginRight: '10px'
    };
    const comment = props.comment;
    const star  = String.fromCodePoint('9733');
    const stars = Array.apply(null, {length: comment.stars}).map((e, i) => (
        <span key={i} style={{color: '#7BF063', fontSize: 25}}>
            {star}
        </span>));

    return (
        <div className={props.className}>
            <span className='hk-userhike-user'>
                <span className='hk-userhike-user-avatar'>
                    <UserAvatar
                        id={comment.user}
                        image={comment.user_avatar_url}
                        name={comment.user_profile}
                        ranger={comment.user_badge_status.is_ranger}
                        staff={comment.user_badge_status.is_staff}
                    />
                </span>
            </span>
            <span className='hk-userhike-hike' style={{display: 'inlineBlock'}}>
                <span className='hk-userhike-user-name'>
                    <a
                        style={usernameStyle}
                        href={`/profile/${comment.user}/${comment.user_profile}/`}
                    >
                        {comment.user_profile}
                    </a>
                    {comment.natural_date}
                    <span id='review_reviewid' /> <span id='actions_reviewid' />
                </span>
            </span>
            <div>
                <div id='text_reviewid' className="reviewText">
                    {comment.notes}
                </div>
                <div>{stars}</div>
            </div>
        </div>
    );
};

export default Comments;
